import React from 'react';

const Travel = () => {
    return (
        <div>
            <h1>Travel</h1>
        </div>
    );
};

export default Travel;